import { z } from "zod";

const parentSchema = z.object({
  id: z.string().array().nonempty(),
});

const querySchema = z.object({
  parent: parentSchema,
});

const BrowseSubdomainSchema = z
  .object({
    search: z.string(),
    query: querySchema,
    page: z.number().min(1, { message: "Page is out of bounds" }),
  })
  .strict();

export default BrowseSubdomainSchema;
